import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
interface TurnstileSlotProps {
  tone?: 'light' | 'dark';
  compact?: boolean;
}

// Mount point for the Cloudflare Turnstile widget (already installed site-wide).
export function TurnstileSlot({
  tone = 'light',
  compact
}: TurnstileSlotProps) {
  const styles = tone === 'light' ? 'border-afb-line bg-afb-light text-afb-muted' : 'border-white/10 bg-white/[0.03] text-white/55';
  return <div className={`cf-turnstile flex items-center gap-2 rounded-input border ${styles} ${compact ? 'h-9 px-3 text-xs' : 'h-[65px] px-4 text-sm'}`} data-sitekey="TURNSTILE_SITE_KEY" role="group" aria-label="Security check by Cloudflare Turnstile" data-id="element-112" data-mp="1i1g5zs9ukofv">
      <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 shrink-0" data-id="element-113" data-mp="141osdsn8ta2e" />
      <span data-id="element-114" data-mp="3trsehlhq41s2">Protected by Cloudflare Turnstile</span>
    </div>;
}